// Stripe Configuration - Dynamic Environment Switching
const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const config = {
  publishableKey: isDev
    ? 'pk_test_51S2oopQREotCSXfATED1bGcIFJUoNLjlT6uKeAdoYPznzActT4wlPAMzk3Djtnrcts2QJ9FLqJqbU90xLLM31UBk00MlD47637'
    : 'pk_live_51S2oopQREotCSXfABEL010bygHhNno25VYQIP7BNT0C4Egfn9FW4Ds1m5QSdDyxbKW3iv7aSnA3O8YJXBgVGjLaC007avkWLIZ',

  webhookSecret: isDev
    ? '' // Test webhook secret if needed
    : 'whsec_ow6u4713I1Ah2v8N8yyqTiKc6GBVgQru',

  priceIds: {
    trial3day: 'price_1SBBbqQREotCSXfAetHvGlXS', // $1.00 3-day trial
    weekly: 'price_1S3bBQQREotCSXfAesB0NqDp',
    monthly: 'price_1S3bDSQREotCSXfAjRKaCv5o',
    yearly: 'price_1S3bF1QREotCSXfADsI2J8qD',
    // New 7-day trial monthly plan
    monthlyWithTrial: isDev
      ? 'price_1SmWgnQREotCSXfAwAHShMlv'
      : 'price_1Sl2CaQREotCSXfAp7rSHl8W'
  },
  environment: isDev ? 'development' : 'production',
  mode: isDev ? 'test' : 'live'
};

export default config;
